<div class="nav-tabs-container">
  <mat-tab-group id="tabContainer" mat-stretch-tabs="false" [selectedIndex]="activeNavTabIndex" (selectedIndexChange)="onSelectedIndexChange($event)" [class.dropdown-tab-active]="activeDropdownTab?.active">
    <!-- Nav tabs -->
    @for (navTab of navTabs; track navTab.tabIndex) {
      <mat-tab [disabled]="navTab.disabled && navTab.disabled()">
        <ng-template mat-tab-label>
          <div [ngClass]="{ 'error-text-color' : navTab.valid && !navTab.valid() }" (click)="onNavTabClick(navTab)">
            <span>{{ navTab.name }}</span>
            @if (navTab.valid && !navTab.valid()) {
              <span class="sap-icon invalid-tab-icon"></span>
            }
          </div>
        </ng-template>
        <ng-container *ngTemplateOutlet="navTab.tabTemplate, context: {tab: navTab}"></ng-container>
      </mat-tab>
    }
  </mat-tab-group>

  <!-- Dropdown tab content -->
  @if (activeDropdownTab.active) {
    <div #dropdownTabComponent>
      <ng-container *ngTemplateOutlet="dropdownTabTemplate, context: {tab: activeDropdownTab}"></ng-container>
    </div>
  }

  <!-- Dropdown -->
  <div #dropdown class="dropdown" [ngClass]="{ 'open': isDropdownOpen }">
    @if (dropdownTabs.length !== 0) {
      <button #dropdownButton id="dropdownToggle" class="btn dropdown-toggle tabdrop-button" (click)="toggleDropdown()" type="button" [ngClass]="activeDropdownTab.active ? 'open' : ''">
        <span class="sap-icon" [ngClass]="{ 'error-text-color' : areTabsValid(dropdownTabs) }">&#xe287;</span>
      </button>
    }
    <div #dropdownMenu id="dropdownMenu" class="dropdown-menu" [style.display]="isDropdownOpen ? '' : 'none'">
      <ul>
        <!-- Dropdown tabs -->
        @for (dropdownTab of dropdownTabs; track dropdownTab.tabIndex) {
          <li class="nav-item" [ngClass]="{ 'active': dropdownTab.active, 'disabled': dropdownTab.disabled && dropdownTab.disabled() }">
            <a class="nav-link" (click)="activateDropdownTab(dropdownTab)" [ngClass]="{ 'error-text-color': dropdownTab.valid && !dropdownTab.valid(), 'disabled': dropdownTab.disabled && dropdownTab.disabled() }">
              <span>{{ dropdownTab.name }}</span>
              @if (dropdownTab.valid && !dropdownTab.valid()) {
                <span class="sap-icon invalid-tab-icon"></span>
              }
            </a>
          </li>
        }
      </ul>
    </div>
  </div>
</div>
